import { gql } from '@common/hooks';

export const SignOutMutation = gql`
  mutation SignOutMutation {
    signOut {
      user
    }
  }
`;

export type SignOutMutationResponse = {
  signOut: {
    user: boolean;
  };
};
